import { withAppCrashIfException } from 'epic';
import { backTestEpics } from 'epic/advisory/backTestEpic';
import { combineEpics } from 'redux-observable';

import { basketAdvisoryEpic } from './basket';

export const advisoryEpic = () =>
  withAppCrashIfException('advisory', combineEpics(basketAdvisoryEpic(), backTestEpics()));
